export default __webpack_public_path__ + "static/media/cross.2c9772ea.svg";